export const LINKEDIN_ACTION_ICON_PATHS: string[] = [
  'images/socialmedia/like-icon-linkedin.svg',
  'images/socialmedia/comment-icon-linkedin.svg',
  'images/socialmedia/repost-icon-linkedin.svg',
  'images/socialmedia/send-icon-linkedin.svg',
];
export const LINKEDIN_REACTIONS_ICON_PATH = 'images/socialmedia/reactions-icon-linkedin.svg';
